// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upsell-carousel {
  position: relative;
}

.upsell-carousel-small {
  height: 380px;
}

.upsell-carousel-default {
  height: 430px;
}

.upsell-carousel-big {
  height: 500px;
}


.upsell-carousel .inline-flex {
  vertical-align: top;
}

.upsell-modal > .modal-wrapper > div {
  max-height: 90%;
}

.upsell-modal-small > .modal-wrapper > div,
.upsell-modal-default > .modal-wrapper > div {
  width: 1000px;
}

.upsell-modal-big > .modal-wrapper > div {
  width: 1075px;
}

.upsell-modal > .modal-wrapper > div > .border-b {
  border: 0;
}

.upsell-modal-small > .modal-wrapper > div > .border-b {
  height: 40px;
}

.upsell-modal--without-footer > .modal-wrapper .footer {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/upsell-modal/UpsellModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".upsell-carousel {\n  position: relative;\n}\n\n.upsell-carousel-small {\n  height: 380px;\n}\n\n.upsell-carousel-default {\n  height: 430px;\n}\n\n.upsell-carousel-big {\n  height: 500px;\n}\n\n\n.upsell-carousel .inline-flex {\n  vertical-align: top;\n}\n\n.upsell-modal > .modal-wrapper > div {\n  max-height: 90%;\n}\n\n.upsell-modal-small > .modal-wrapper > div,\n.upsell-modal-default > .modal-wrapper > div {\n  width: 1000px;\n}\n\n.upsell-modal-big > .modal-wrapper > div {\n  width: 1075px;\n}\n\n.upsell-modal > .modal-wrapper > div > .border-b {\n  border: 0;\n}\n\n.upsell-modal-small > .modal-wrapper > div > .border-b {\n  height: 40px;\n}\n\n.upsell-modal--without-footer > .modal-wrapper .footer {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
